<mat-card class="balance-benefits-panel default has-progress-bar" data-balance-benefits-panel>
  <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'"></mat-progress-bar>

  @if (!readOnly && !embedded) {
    <mat-card-title class="balance-benefits-panel__title">
      <span class="balance-benefits-panel__heading text-primary uppercase text-sm">
        {{ 'balance.benefits.title' | translate }}
      </span>
      <mmx-balance-benefits-options-menu
        [form]="form"
        [hasSecondaryInsurance]="hasSecondaryInsurance"
        (committed)="onCommitted()">
      </mmx-balance-benefits-options-menu>
    </mat-card-title>
  }

  <mat-card-content class="p-0">
    @if (!readOnly && insuranceSelectionResolved && primaryInsurance === null) {
      <p class="balance-benefits-panel__self-pay-notice text-sm" data-balance-benefits-self-pay-notice>
        {{ 'estimate.benefits-self-pay' | translate }}
      </p>
    }
    @if (!readOnly && primaryInsurance?.status === PatientInsuranceStatus.NotVerified) {
      <p class="balance-benefits-panel__self-pay-notice text-sm" data-balance-benefits-unverified-notice>
        {{ 'estimate.benefits-unverified' | translate }}
      </p>
    }
    @if (!readOnly) {
      @if (primaryInsuranceOptions.length > 1) {
        <mmx-balance-insurance-picker
          class="balance-benefits-panel__insurance-picker"
          labelKey="common.primary-insurance"
          [options]="primaryInsuranceOptions"
          [selected]="primaryInsurance"
          (selectionChange)="primaryInsuranceChange.emit($event)">
        </mmx-balance-insurance-picker>
      }
      @if (hasSecondary && secondaryInsuranceOptions.length > 1) {
        <mmx-balance-insurance-picker
          class="balance-benefits-panel__insurance-picker"
          labelKey="common.secondary-insurance"
          [options]="secondaryInsuranceOptions"
          [selected]="secondaryInsurance"
          (selectionChange)="secondaryInsuranceChange.emit($event)">
        </mmx-balance-insurance-picker>
      }
    }
    <table class="balance-benefits-panel__table" cellspacing="0" cellpadding="0">
      <colgroup>
        <col class="balance-benefits-panel__col-item" />
        <col class="balance-benefits-panel__col-amount" />
      </colgroup>
      <thead>
        <tr class="balance-benefits-panel__header-row">
          <th class="balance-benefits-panel__header-cell">
            <span class="text-primary uppercase text-sm">
              {{ 'balance.benefits.column.item' | translate }}
            </span>
          </th>
          <th class="balance-benefits-panel__header-cell">
            <span class="text-primary uppercase text-sm">
              {{ 'balance.benefits.column.amount' | translate }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          mmxBalanceBenefitRow
          labelKey="balance.benefits.row.copay"
          format="currency"
          [primaryControl]="form.controls.primary.controls.copayment"
          [secondaryControl]="form.controls.secondary.controls.copayment"
          [originalPrimary]="originalPrimary?.copayment ?? 0"
          [originalSecondary]="originalSecondary?.copayment ?? 0"
          [ambiguousPrimary]="!!originalPrimary?.copaymentAmbiguous"
          [ambiguousSecondary]="!!originalSecondary?.copaymentAmbiguous"
          [hasSecondary]="hasSecondary"
          (committed)="onCommitted()">
        </tr>
        <tr
          mmxBalanceBenefitRow
          labelKey="balance.benefits.row.deductible"
          format="currency"
          [primaryControl]="form.controls.primary.controls.deductible"
          [secondaryControl]="form.controls.secondary.controls.deductible"
          [originalPrimary]="originalPrimary?.deductible ?? 0"
          [originalSecondary]="originalSecondary?.deductible ?? 0"
          [hasSecondary]="hasSecondary"
          (committed)="onCommitted()">
        </tr>
        <tr
          mmxBalanceBenefitRow
          labelKey="balance.benefits.row.coinsurance"
          format="percent"
          [primaryControl]="form.controls.primary.controls.coinsurance"
          [secondaryControl]="form.controls.secondary.controls.coinsurance"
          [originalPrimary]="originalPrimary?.coinsurance ?? 0"
          [originalSecondary]="originalSecondary?.coinsurance ?? 0"
          [ambiguousPrimary]="!!originalPrimary?.coinsuranceAmbiguous"
          [ambiguousSecondary]="!!originalSecondary?.coinsuranceAmbiguous"
          [hasSecondary]="hasSecondary"
          (committed)="onCommitted()">
        </tr>
        <tr
          mmxBalanceBenefitRow
          labelKey="balance.benefits.row.out-of-pocket"
          format="currency-nullable"
          [primaryControl]="form.controls.primary.controls.outOfPocketMax"
          [secondaryControl]="form.controls.secondary.controls.outOfPocketMax"
          [originalPrimary]="originalPrimary?.outOfPocketMax ?? null"
          [originalSecondary]="originalSecondary?.outOfPocketMax ?? null"
          [hasSecondary]="hasSecondary"
          (committed)="onCommitted()">
        </tr>
      </tbody>
    </table>
  </mat-card-content>
</mat-card>
